// Selectors over state.advertising.
import { AdvertisingDecision } from "./advertisingActionCreators";
import { AdvertisingState } from "./advertisingReducer";
import { AdvertisingStatus } from "./advertisingConstants";

type WithAdvertising = { advertising?: AdvertisingState };

export const getAdvertisingHomeBlockAd = (state: WithAdvertising): AdvertisingDecision | null =>
	state.advertising ? state.advertising.ad : null;

export const getAdvertisingHomeBlockStatus = (state: WithAdvertising): AdvertisingStatus | null =>
	state.advertising ? state.advertising.status : null;
